module.exports = __webpack_public_path__ + "static/media/edb.801cab02.jpeg";